var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"counts"},[_c('Search'),_c('MapView'),_c('Legend')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sources"},[_c('div',[_vm._v("地图来源：天地图     审图号：GS（2024）0568号")])])
}]

export { render, staticRenderFns }